import moment from "moment-timezone";

window.moment = moment;
